import { useContent } from "@/content/ContentProvider";
import type { SiteContent } from "@/content/defaults";

interface PageHeroProps {
  page: keyof SiteContent["pages.hero"];
}

export default function PageHero({ page }: PageHeroProps) {
  const { tag, titleLine1, titleLine2, description, image } = useContent("pages.hero")[page];
  const title = (
    <>
      {titleLine1}
      <br />
      <span className="text-primary-500">{titleLine2}</span>
    </>
  );

  return (
    <section className="relative overflow-hidden bg-foreground-950 pb-16 pt-32 md:pb-24 md:pt-44">
      {image && (
        <img
          src={image}
          alt=""
          className="absolute inset-0 h-full w-full object-cover object-top opacity-40"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/80 to-foreground-950" />
      <div className="pointer-events-none absolute inset-0 grain-light opacity-30" />

      <div className="relative mx-auto max-w-content px-5 md:px-8">
        <p className="font-label text-xs tracking-[0.25em] text-primary-500">{tag}</p>
        <h1 className="mt-4 font-heading text-4xl font-black tracking-tight text-white md:text-6xl">
          {title}
        </h1>
        {description && (
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70 md:text-lg">
            {description}
          </p>
        )}
      </div>
    </section>
  );
}